import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { DATA_TESTIDS } from '../../lib/utils/constant/data-testId';

import { Heading, Info, Label, Value } from './CardCommon';
import IHSpinner from './IHSpinner';

const StatusPanel = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 24px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background: #ffffff;
`;

const LoaderWrap = styled.div`
  margin-bottom: 20px;
`;

const Summary = styled.div`
  width: 100%;
  max-width: 480px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eeeeee;
`;

const SummaryValue = styled(Value)`
  margin-bottom: 0;
`;

const formatTime = (timeSelected) => {
  if (!timeSelected?.start || !timeSelected?.end) {
    return '';
  }

  const start = moment(timeSelected.start);
  const end = moment(timeSelected.end);
  return `${start.format('ddd, MMM D')} from ${start.format('h:mm A')} - ${end.format('h:mm A')}`;
};

export default function SchedulingShowingStatus({ unitAddress, timeSelected }) {
  const selectedTime = formatTime(timeSelected);

  return (
    <Grid container justifyContent="center" spacing={0}>
      <Grid item xs={12} sm={10} md={8}>
        <StatusPanel role="status" aria-live="polite" data-testid={DATA_TESTIDS.SCHEDULE.SCHEDULING_STATUS}>
          <LoaderWrap>
            <IHSpinner />
          </LoaderWrap>
          <Heading>Scheduling your Self-Tour</Heading>
          <Info>
            We're confirming your selected time and preparing your tour details. This can take up to 30 seconds.
          </Info>
          {(selectedTime || unitAddress) && (
            <Summary>
              {selectedTime && (
                <SummaryValue centered>
                  <Label>Selected time</Label>
                  {selectedTime}
                </SummaryValue>
              )}
              {unitAddress && (
                <SummaryValue centered>
                  <Label>Home</Label>
                  {unitAddress}
                </SummaryValue>
              )}
            </Summary>
          )}
        </StatusPanel>
      </Grid>
    </Grid>
  );
}
